// Angular imports
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

// Local imports
import { StepInfo } from '../../interface/steps-info';
import { Steps } from '../../enum/steps';

@Component({
  selector: 'tgx-onboarding-company-progressbar-steps',
  templateUrl: './onboarding-company-progressbar-steps.component.html',
  styleUrls: ['./onboarding-company-progressbar-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OnboardingCompanyProgressbarStepsComponent implements OnChanges {
  protected progressBar = 10;
  protected position: StepInfo[] = [];
  @Input() private steps: Map<Steps, StepInfo<Steps>>;
  @Input() private isBuyer: boolean;
  @Input() private isSeller: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['steps'] && changes['steps'].currentValue) {
      this.updateProgress();
    }
  }

  private updateProgress(): void {
    this.position = [];
    this.steps.forEach((stepInfo) => {
      if (stepInfo.actualStep) {
        this.progressBar = stepInfo.width;
      }

      if (!stepInfo.hidden) {
        this.position.push(stepInfo);
      }
    });
  }
}
